import { render, staticRenderFns } from "./SurveyRadioOption.vue?vue&type=template&id=b589edfa"
import script from "./SurveyRadioOption.vue?vue&type=script&lang=js"
export * from "./SurveyRadioOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports